/**
 * Job Post Form Hook
 * 
 * Creates and manages the single form instance for all steps
 */

import { useForm, UseFormReturn } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { jobPostValidationSchema, JobPostFormData } from '../schemas/jobPostValidation';
import { JobPostMode } from '../types';
import { getInitialFormValues } from '../utils/formTransformers';
import { useFormPersistence, PersistenceStatus } from './useFormPersistence';

interface UseJobPostFormOptions {
  mode: JobPostMode;
  jobPostId?: string;
  draftId: string;
  initialData?: Partial<JobPostFormData>;
}

export interface UseJobPostFormReturn {
  form: UseFormReturn<JobPostFormData>;
  saveStatus: PersistenceStatus;
}

export const useJobPostForm = (
  options: UseJobPostFormOptions
): UseJobPostFormReturn => {
  const { mode, jobPostId, draftId, initialData } = options;

  const form = useForm<JobPostFormData>({
    resolver: zodResolver(jobPostValidationSchema) as any,
    defaultValues: initialData || getInitialFormValues(mode, jobPostId),
    mode: 'onChange',
    shouldUnregister: false,
    reValidateMode: 'onChange',
  });

  // Setup persistence and get status
  const saveStatus = useFormPersistence(form as any, mode, draftId);

  return { form, saveStatus };
};


